import { DataBean } from "../DataBean";

export class JobRequisition extends DataBean {

    public async getJobRequisition(idjobrequisition: number): Promise<any> {
        return this.getCustomService(
            "PayRollERP",
            "com.orange.people.payroll.bean.JobRequisition_getJobRequisition_Number",
            [idjobrequisition]
        );
    }

    public async getJobRequisitionCatalogPorPropiedades(properties: any, maxRows: number): Promise<any> {
        return this.getCustomService(
            "PayRollERP",
            "java.util.List_getJobRequisitionCatalogPorPropiedades_java.util.Map_Number",
            [properties, maxRows]
        );
    }

    public async getJobRequisitionRender(page: number, rows: number, props: Record<string, any>): Promise<any> {
        return this.getCustomService(
            "PayRollERP",
            "com.advantage.shared.Report_getJobRequisitionRender_Number_Number_java.util.Map",
            [page, rows, props]
        );
    }

    public async deleteJobRequisition(idjobrequisition: number): Promise<any> {
        return this.getCustomService("PayRollERP", "boolean_deleteJobRequisition_Number", [idjobrequisition]);
    }

    public async updateJobRequisition(bean: any): Promise<any> {
        return this.getCustomService(
            "PayRollERP",
            "com.orange.people.payroll.bean.JobRequisition_updateJobRequisition_com.orange.people.payroll.bean.JobRequisition",
            [
                {
                    DataBeanProperties: bean,
                    DataBeanName: "com.orange.people.payroll.bean.JobRequisition",
                },
            ]
        );
    }

}
